module.exports = __webpack_public_path__ + "img/xinxitianxie.38ab1e72.png";